import React from 'react';
import { AlertTriangle, CheckCircle2, Scale } from 'lucide-react';

const box = 'mt-2 flex items-start gap-2 border px-3 py-2 text-xs';

/** What approving this row will do to the part's Weight (g) in Part Master. */
export const WeightChangeAlert = ({ alert, sheetWeight, testId }) => {
  if (!alert) return null;
  const partWeight = alert.part_net_weight_grams == null ? null : Number(alert.part_net_weight_grams);
  const sheet = sheetWeight === '' || sheetWeight == null ? null : Number(sheetWeight);
  const label = alert.internal_part_no || 'the part';

  if (!sheet) {
    return (
      <div className={`${box} border-amber-400 bg-amber-50 text-amber-900`} data-testid={testId}>
        <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0" />
        <span>
          {partWeight
            ? `No weight on this row — ${label} keeps its current ${partWeight} g.`
            : 'No weight on this row — add the weight per piece so per-kg rates can be costed.'}
        </span>
      </div>
    );
  }
  if (!alert.part_id) {
    return (
      <div className={`${box} border-slate-300 bg-slate-50 text-slate-700`} data-testid={testId}>
        <Scale className="mt-0.5 h-3.5 w-3.5 shrink-0" />
        <span>A new part will be created with Weight {sheet} g.</span>
      </div>
    );
  }
  if (partWeight === null) {
    return (
      <div className={`${box} border-slate-300 bg-slate-50 text-slate-700`} data-testid={testId}>
        <Scale className="mt-0.5 h-3.5 w-3.5 shrink-0" />
        <span>Will set <strong>{label}</strong> Weight (g) to <strong>{sheet} g</strong> on approval.</span>
      </div>
    );
  }
  if (Math.abs(partWeight - sheet) > 0.0001) {
    return (
      <div className={`${box} border-red-400 bg-red-50 font-medium text-red-800`} data-testid={testId}>
        <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0" />
        <span>
          Weight change — approving overwrites <strong>{label}</strong>: {partWeight} g → <strong>{sheet} g</strong>.
          Edit the weight above if the sheet is wrong.
        </span>
      </div>
    );
  }
  return (
    <div className={`${box} border-emerald-300 bg-emerald-50 text-emerald-800`} data-testid={testId}>
      <CheckCircle2 className="mt-0.5 h-3.5 w-3.5 shrink-0" />
      <span>Weight matches <strong>{label}</strong> ({sheet} g).</span>
    </div>
  );
};
